module.exports = __webpack_public_path__ + "img/lunbo222.6dbaa86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo222.png
// module id = sYc3
// module chunks = 0